import { MS_PROVIDER_PRICING_WATCH_FIELDS, MS_PROVIDER_TOKEN_UNIT } from '../../capabilities/model-subscription-provider/constants';
import type { ResourceConfigEntry, SkuModuleMeta } from '../../platform/pipeline-kernel/types';

/** 下单预览「资源配置」展示的 display 行 id（与 projections 对齐） */
export const MS_ORDER_RESOURCE_DISPLAY_IDS = [
  'vendor',
  'model',
  'token_total',
  'token_input',
  'token_output',
  'requests_total',
  'input_rate',
  'output_rate',
] as const;

export const MS_TOKEN_RESOURCE_CONFIG: ResourceConfigEntry = {
  requirement: '',
  code: 'Token',
  description: 'Token',
  unit: MS_PROVIDER_TOKEN_UNIT,
  // 厂商设备选型 + Token / 配额变更均需触发询价与预览刷新
  watchFields: [
    'useSubResourcePricing',
    'billingTotalTokens',
    'inputTokens',
    'outputTokens',
    'requests',
    'inputTokensValue',
    'inputTokensWindowSeconds',
    'outputTokensValue',
    'outputTokensWindowSeconds',
    'switches',
    'strategyName',
    'strategyDisplayName',
    ...MS_PROVIDER_PRICING_WATCH_FIELDS,
  ],
  displayIds: [...MS_ORDER_RESOURCE_DISPLAY_IDS],
};

export const MS_RESOURCE_CONFIGS: ResourceConfigEntry[] = [MS_TOKEN_RESOURCE_CONFIG];

export const MS_SKU_MODULE_META: Record<string, SkuModuleMeta> = {
  baseInfo: {
    resource: false,
    presetCheckFields: ['name'],
  },
  modelProvider: {
    resource: true,
    presetCheckFields: ['strategyName'],
    /** 下单允许换模型策略；Token 有预填则锁 */
    orderMutableFields: ['ms.strategy'],
    quantityFields: ['ms.billingTotalTokens', 'ms.inputTokens', 'ms.outputTokens'],
    quantityPresetPaths: {
      'ms.billingTotalTokens': ['billingTotalTokens'],
      'ms.inputTokens': ['inputTokens'],
      'ms.outputTokens': ['outputTokens'],
    },
  },
  other: {
    resource: false,
    /** 白名单列表项级锁；请求/速率等标量仍按预填只读（UI） */
    orderListItemLock: true,
    presetCheckFields: ['allowedClientCIDRs', 'allowedClientIPs'],
  },
};
